export const DEFAULT_LANGUAGE = 'en';
export const RESOURCE_NAME = 'learnleaf';
export const STORAGE_KEY = 'learnleaf-language';
export const CACHE_TTL_MS = 60 * 60 * 1000; // 1 hour
export const TRANSLATIONS_TABLE = 'translations';
